/* eslint-disable import/prefer-default-export */
export const LOADING_ADDRESSES_UPDATE = 'LOADING_ADDRESSES_UPDATE';
export const MASTER_TENANT_CURRENCIES_UPDATE = 'MASTER_TENANT_CURRENCIES_UPDATE';
export const MASTER_TENANT_RFQ_MANAGEMET_CLIENT = 'MASTER_TENANT_RFQ_MANAGEMET_CLIENT';
export const MASTER_TENANT_APPROVALS_ADDRESSES_UPDATE = 'MASTER_TENANT_APPROVALS_ADDRESSES_UPDATE';
export const MASTER_TENANT_APPROVALS_WITHDRAWALS_UPDATE = 'MASTER_TENANT_APPROVALS_WITHDRAWALS_UPDATE';
export const MASTER_TENANT_ORDERS_URL_OPTIONS_SET_UPDATE = 'MASTER_TENANT_ORDERS_URL_OPTIONS_SET_UPDATE';
export const MASTER_TENANT_STRATEGIES_URL_OPTIONS_SET_UPDATE = 'MASTER_TENANT_STRATEGIES_URL_OPTIONS_SET_UPDATE';
